import { motion } from 'framer-motion';
import React from 'react';
import { LogoSpinner } from 'shared-react';
import styled from 'styled-components';

const SpinnerLayout = styled(motion.div)`{
  align-items: center;
  bottom: 0;
  display: flex;
  justify-content: center;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
}`;

const AppSpinner = React.forwardRef<HTMLDivElement>((_, ref) => {
  return (
    <SpinnerLayout
      ref={ref}
      initial={{opacity: 0, top: 0}}
      animate={{opacity: [0, 1], top: [50, 0], transition: {duration: .2}}}
      transition={{type: 'spring', duration: .4}}
      exit={{top: [0, -20, 100], opacity: [1, 1, 0]}}
    >
      <LogoSpinner />
    </SpinnerLayout>
  )
});

export default AppSpinner;
